/* The tester's "show me what a player would see" switch.

Meaningful only while the server runs with DISABLE_FOG_OF_WAR (it tells us so in game-config). The
server does the redacting — per connection over the socket, per request over REST with a header —
so this module only remembers the choice and tells listeners when it changes. */

const KEY = "hvz-fog-preview"
const listeners = new Set()

export const loadFogPreview = () => {
  try {
    return localStorage.getItem(KEY) === "1"
  } catch {
    return false
  }
}

export const saveFogPreview = (enabled) => {
  try {
    if (enabled) localStorage.setItem(KEY, "1")
    else localStorage.removeItem(KEY)
  } catch {
    // Storage unavailable: the choice lives for this session only.
  }
  listeners.forEach((listener) => listener(enabled))
}

export const subscribeFogPreview = (listener) => {
  listeners.add(listener)
  return () => listeners.delete(listener)
}
